import React from 'react';

const Image = (props = {}) => {
  const { alt, src, src2x, style, webpSrc2x, webpSrc } = props;

  const srcSet = src2x ? `${src2x} 2x` : undefined;
  const webpSrcSet = webpSrc2x ? `${webpSrc2x} 2x` : webpSrc;

  return (
    <picture>
      <source type="image/webp" srcSet={webpSrcSet} />
      <img alt={alt} src={src} srcSet={srcSet} style={style} />
    </picture>
  );
};

export default Image;
